
angular.module('bmsApp.employeeUnavailability', [])

	.config([
		'$stateProvider',
		'$urlRouterProvider',
		'BMSPermission', function config(
			$stateProvider,
			$urlRouterProvider,
			BMSPermission
		) {

			$stateProvider

				.state('main.employee.index.unavailability', {
					url: '/unavailability',
					views: {
						'content@main.employee': {
							templateUrl: "ng/employee/employeeUnavailability/templates/EmployeeUnavailability.html",
							controller: 'EmployeeUnavailabilityCtrl'
						}
					},
					ncyBreadcrumb: {label: 'Employee Unavailability'}
				})

			;

		}]);
